import { MapTo } from "@adobe/aem-react-editable-components";
import { ReferralPersonalCode } from "@jti/loyalty";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const referralPersonalCodeEditConfig = {
    emptyLabel: "ReferralPersonalCode",
    isEmpty: (props) => {
        if (props.variant === "withBackgroundImage") {
            return !props.backgroundimage || !props.backgroundimagemobile;
        }
        return false;
    },
    getProps: (props) => ({
        topHeader: props.topHeader,
        header: props.header,
        codeTitle: props.codeTitle,
        shareTitle: props.shareTitle,
        description: props.description,
        variant: props.variant,
        referralPageVariant: props.referralPageVariant,
        items: props.items,
        infoTitle: props.infoTitle,
        smallText: props.smallText,
        backgroundimage: props.backgroundimage,
        backgroundimagetablet: props.backgroundimagetablet,
        backgroundimagemobile: props.backgroundimagemobile,
        signInTitle: props.signInTitle,
        signInUrl: props.signInUrl,
        registerUrl: props.registerUrl,
        registerTitle: props.registerTitle,
        isInEditor: props.isInEditor,
        withBottomCta: props.withBottomCta,
        bottomCtaLabel: props.bottomCtaLabel,
        bottomCtaLink: props.bottomCtaLink,
    }),
};
export default MapTo("loyalty/components/referralpersonalcode")(withAemAuthoring(ReferralPersonalCode, referralPersonalCodeEditConfig));
